export default "__VITE_ASSET__BU8zkMpA__"